import { ArticleByline, ArticleCategory } from '@/components/common/Article'
import { usePage } from '@/components/providers/PageProvider'

import styles from './GuideHeader.module.scss'

export const GuideHeader = () => {
  const { page } = usePage()
  const article = page?.article

  if (!article) return null

  const { author, category, date, excerpt, shortTitle, title } = article

  const articleTitle = shortTitle || title

  return (
    <div className={styles.container}>
      <ArticleCategory category={category} />
      <h1 className={styles.title} dangerouslySetInnerHTML={{ __html: articleTitle }} />
      <ArticleByline author={author} date={date} />
      {excerpt && <p className={styles.excerpt} dangerouslySetInnerHTML={{ __html: excerpt }} />}
    </div>
  )
}
